import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchNotifications } from '../api/notification';
import { NotificationQuery } from '../../constants/notification';
import { useEnvContext } from '../../modules/EnvProvider';

export default function useFetchNotification() {
  const { targetEnv } = useEnvContext();

  const queryResult = useInfiniteQuery(
    ['fetchNotifications'],
    async ({ pageParam }: { pageParam?: number }) => {
      const requestQuery: NotificationQuery | null = pageParam
        ? { cursor: pageParam, direction: 'before', limit: '20' }
        : null;
      const response = await fetchNotifications(requestQuery, targetEnv);

      return response.data.data;
    },
    {
      getNextPageParam: (lastPage) => {
        const { hasNext, notificationInfos = [] } = lastPage;

        if (hasNext && notificationInfos.length > 0) {
          return notificationInfos[notificationInfos.length - 1].id;
        }

        return undefined;
      },
      retry: false,
    },
  );

  return {
    ...queryResult,
    data: queryResult.data?.pages,
  };
}
